import { createTheme } from '@mui/material'
import '@fontsource/be-vietnam-pro'

declare module '@mui/material/styles' {
  interface Palette {
    gray: Palette['primary']
  }

  interface PaletteOptions {
    gray: PaletteOptions['primary']
  }

  interface PaletteColor {
    semiTransparent?: string
  }

  interface SimplePaletteColorOptions {
    semiTransparent?: string
  }
}

declare module '@mui/material/IconButton' {
  interface IconButtonPropsColorOverrides {
    gray: true
  }
}

export type EiduThemeOptions = {
  backgroundColor?: string
  textColor?: string
  organizationColor?: string
  organizationTextColor?: string
}

const DEFAULT_PRIMARY = '#5c3cd8'
const DEFAULT_PRIMARY_SEMI = '#ede7faaa'
const DEFAULT_SECONDARY = '#f3c049'
const DEFAULT_GRAY = '#808080'

const buildEiduTheme = ({
  backgroundColor,
  textColor,
  organizationColor,
  organizationTextColor,
}: EiduThemeOptions = {}) =>
  createTheme({
    palette: {
      mode: 'light',
      primary: {
        main: organizationColor ?? DEFAULT_PRIMARY,
        semiTransparent: DEFAULT_PRIMARY_SEMI,
        ...(organizationTextColor ? { contrastText: organizationTextColor } : {}),
      },
      ...(backgroundColor ? { background: { default: backgroundColor } } : {}),
      ...(textColor ? { text: { primary: textColor, secondary: textColor } } : {}),
      secondary: {
        main: DEFAULT_SECONDARY,
      },
      gray: {
        main: DEFAULT_GRAY,
      },
    },
    typography: {
      fontFamily: '"Be Vietnam Pro"',
    },
  })

export default buildEiduTheme
